import { axiosInstance } from "../axiosInstance";
import {
  EditNotificationTypeRequest,
  EditNotificationTypeResponse,
} from "./types";

export const editNotificationType = async (
  requestData: EditNotificationTypeRequest,
): Promise<EditNotificationTypeResponse> => {
  const { id, ...updateData } = requestData;

  const response = await axiosInstance.put<EditNotificationTypeResponse>(
    `/api/private/notification-types/${id}`,
    updateData,
  );
  return response.data;
};
